import * as React from 'react';
import { AvatarBase } from './Avatar.base';
import { st, classes } from './Avatar.st.css';
import { AvatarDefaultProps, AvatarProps, AvatarSize } from './types';

/** Avatar is a type of element that visually represents a user, either as an image, placeholder or text (name initials). */
export class Avatar extends React.Component<AvatarProps> {
  static displayName = 'Avatar';
  static defaultProps: AvatarDefaultProps = {
    size: AvatarSize.medium,
  };

  render() {
    const { className, size, ...rest } = this.props;

    return (
      <AvatarBase {...rest} className={st(classes.root, { size }, className)} />
    );
  }
}
